'use client';

import { Button, Textarea } from '@shared/components/shadcn';
import { LottolandSmileLogo } from '@shared/icons';
import { IconBadge } from '../../../IconBadge/IconBadge';
import type { CommentProps } from '../../types';

function Comment({ selectedLabel = '', comment, onCommentChange, onSubmit, title, commentsLabel, submitButtonText, ...props }: CommentProps) {
  return (
    <div className="flex flex-col gap-5 px-6 py-10 h-full md:h-auto" {...props}>
      <IconBadge icon={LottolandSmileLogo} shapeType="square" />
      <div className="flex flex-col gap-10 flex-grow">
        <h2 id="whyLeavingCommentTitle" className="heading-4">{`${title} ${selectedLabel}`}</h2>
        <div className="flex flex-col gap-2">
          <label htmlFor="whyLeavingCommentArea" className="paragraph-explanatory-strong">
            {commentsLabel}
          </label>
          <Textarea
            id="whyLeavingCommentArea"
            value={comment}
            onChange={onCommentChange}
            className="min-h-[120px] resize-none border border-border"
            aria-labelledby="whyLeavingCommentTitle"
            data-track-name="Comments"
            data-track-privacy="Mask"
            data-testid="why-leaving-comment-textarea"
            maxLength={200}
          />
        </div>
        <div data-track-container="Actions">
          <Button onClick={() => onSubmit()} data-testid="why-leaving-submit-button" data-track-name="Continue" data-track-reason={selectedLabel}>
            {submitButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

export { Comment };
